import { Component, OnInit, ChangeDetectorRef, Input, AfterContentChecked } from '@angular/core';
import { CvNumberLocalizePipe } from 'src/app/reusables/pipes/cv-number-localize.pipe';
import { PointStoreProductEditService } from '../../services/point-store-product-edit.service';
import { CompanySettingsService } from '../../../../../reusables/services/company-settings.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-point-store-product-summary',
  templateUrl: './point-store-product-summary.component.html',
  styleUrls: ['./point-store-product-summary.component.scss']
})
export class PointStoreProductSummaryComponent implements OnInit, AfterContentChecked {

  pspes = null;
  qty = 0;
  initialVariationPrice: any = 0;
  saleVariationFlag = false;

  @Input() next: (args: number) => void;
  @Input() cancel: () => void;
  @Input() save: () => void;

  constructor(
    private pointStoreProductEditService: PointStoreProductEditService,
    private companySettingsService: CompanySettingsService,
    private cvNumberLocalize: CvNumberLocalizePipe,
    private changeDetector: ChangeDetectorRef,
    private cvLocalizationService: CVLocalizationService,
  ) {
    this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;
  }

  async ngOnInit() {
    await this.companySettingsService.loadLoggedInCompanyValues();;
  }

  ngAfterContentChecked() {
    this.changeDetector.detectChanges();
  }

  getTitle() {

  }

  getPreviewSource() {
    if (this.pspes == null || this.pspes.modifiedPointStoreProduct == null)
      return "";

    if (this.pspes.modifiedPointStoreProduct.imageString != null && this.pspes.modifiedPointStoreProduct.imageString.length > 0)
      return this.pspes.modifiedPointStoreProduct.imageString[0].source;
    else if (this.pspes.modifiedPointStoreProduct.ProductImageID != 0 && (this.pspes.modifiedPointStoreProduct.imageString == null || this.pspes.modifiedPointStoreProduct.imageString.length <= 0))
      return "../Admin/ImageResizer.aspx?imgid=" + this.pspes.modifiedPointStoreProduct.ProductImageID + "&w=auto&h=190";
    else
      return "../Admin/ImageResizer.aspx?imgid=-15&w=auto&h=190";
  };

  getProductInfo(property) {
    if (this.pspes == null || this.pspes.modifiedPointStoreProduct == null)
      return "";

    switch (property) {
      case "title":
        return this.pspes.modifiedPointStoreProduct.Title;
        break;
      case "description":
        return this.pspes.modifiedPointStoreProduct.Description;
        break;
      case "category":
        return this.pspes.modifiedPointStoreProduct.Category;
        break;
      case "subCategory":
        return this.pspes.modifiedPointStoreProduct.SubCategory;
        break;
      case "price":
        return this.pspes.modifiedPointStoreProduct.Price;
        break;
      case "quantity":
        if (this.pspes.modifiedPointStoreProduct.HasProductVariations) {
          var totalQuantity = null;
          this.pspes.modifiedPointStoreProduct.VariationsData.forEach((variation) => {
            if (variation.VariationQuantity != null)
              totalQuantity = totalQuantity != null ? totalQuantity + Number(variation.VariationQuantity) : Number(variation.VariationQuantity);
          });
          if (totalQuantity == null)
            return this.getLocalizationText('MarketPlace_Management', 'Unlimited', 'Unlimited');
          else
            return totalQuantity;
        } else {
          if (this.pspes.modifiedPointStoreProduct.Quantity == null || this.pspes.modifiedPointStoreProduct.Quantity.length <= 0)
            return this.getLocalizationText('MarketPlace_Management', 'Unlimited', 'Unlimited');
          else return this.pspes.modifiedPointStoreProduct.Quantity;
        }
        break;
      case "productStart":
        return this.pspes.modifiedPointStoreProduct.ProductStart_ForView;
        break;
      case "productEnd":
        if (this.pspes.modifiedPointStoreProduct.ProductEnd_ForView == null || this.pspes.modifiedPointStoreProduct.ProductEnd_ForView.length <= 0)
          return "Ongoing";
        else return this.pspes.modifiedPointStoreProduct.ProductEnd_ForView;
        break;
    }
  };

  getAgentPrice() {
    if (this.pspes == null || this.pspes.modifiedPointStoreProduct == null)
      return "";

    if (this.isSaleActive()) {
      return Math.ceil(this.pspes.modifiedPointStoreProduct.Price * ((100 - this.pspes.modifiedPointStoreProduct.Sale) / 100));
    }
    return this.pspes.modifiedPointStoreProduct.Price;
  };

  getVariationPrice() {
    if (this.pspes == null || this.pspes.modifiedPointStoreProduct == null)
      return "";

    this.initialVariationPrice = this.pspes.modifiedPointStoreProduct.VariationsData.reduce((prev, curr) => {
      let prevValue = prev.VariationPrice;
      let currValue = curr.VariationPrice;
      if (prev.VariationOnSale)
        prevValue = prev.VariationPrice - (prev.VariationPrice * (this.pspes.modifiedPointStoreProduct.Sale / 100));
      if (curr.VariationOnSale)
        currValue = curr.VariationPrice - (curr.VariationPrice * (this.pspes.modifiedPointStoreProduct.Sale / 100));
      return prevValue < currValue ? prev : curr;
    });

    return this.initialVariationPrice.VariationPrice;
  }

  checkSaleVariationPrice() {
    this.saleVariationFlag = false;
    this.pspes.modifiedPointStoreProduct.VariationsData.forEach((variation) => {
      if (variation.VariationPrice == this.initialVariationPrice.VariationPrice && variation.VariationOnSale)
        this.saleVariationFlag = true;
    });
    if (this.saleVariationFlag) {
      return Math.ceil(this.initialVariationPrice.VariationPrice - (this.initialVariationPrice.VariationPrice * this.pspes.modifiedPointStoreProduct.Sale / 100));
    }
  }

  getDisplaySettingValue(sValue, isStartDate) {
    if (this.pspes == null || this.pspes.modifiedPointStoreProduct == null)
      return "-";

    var isChecked = false;
    var property = null;

    switch (sValue) {
      case 'carousel':
        isChecked = this.pspes.modifiedPointStoreProduct.IsCarouselChecked;
        if (isStartDate) property = this.pspes.modifiedPointStoreProduct.CarouselStart_ForView;
        else property = this.pspes.modifiedPointStoreProduct.CarouselEnd_ForView;
        break;
      case 'featured':
        isChecked = this.pspes.modifiedPointStoreProduct.IsFeaturedChecked;
        if (isStartDate) property = this.pspes.modifiedPointStoreProduct.FeatureStart_ForView;
        else property = this.pspes.modifiedPointStoreProduct.FeatureEnd_ForView;
        break;
      case 'sale':
        isChecked = this.pspes.modifiedPointStoreProduct.IsOnSaleChecked;
        if (isStartDate) property = this.pspes.modifiedPointStoreProduct.SaleStart_ForView;
        else property = this.pspes.modifiedPointStoreProduct.SaleEnd_ForView;
        break;
    }

    if (isChecked && property != null && property.toString().length > 0)
      return property;
    return "-";
  };

  isSaleActive() {
    if (this.pspes == null || this.pspes.modifiedPointStoreProduct == null)
      return false;

    if ((this.pspes.modifiedPointStoreProduct.SaleEnd == null ||
      (this.pspes.modifiedPointStoreProduct.SaleEnd != null)) &&
      this.pspes.modifiedPointStoreProduct.SaleStart != null)
      return true;

    return false;
  };

  getQty() {
    if (this.pspes.modifiedPointStoreProduct != null && this.pspes.modifiedPointStoreProduct.VariationsData != null)
      return Object.values(this.pspes.modifiedPointStoreProduct.VariationsData).length;
  }

  getDollarFromCoinConversion() {
    if (this.pspes == null || this.pspes.modifiedPointStoreProduct == null || this.pspes.modifiedPointStoreProduct.Price == null) return "";

    const coinToCurrencyRatio = this.companySettingsService.getCompanyValueByFieldName("CoinToCurrencyValue");
    if (!coinToCurrencyRatio) return "";
    return " ($" + ((this.pspes.modifiedPointStoreProduct.Price / coinToCurrencyRatio.NumericValue)).toFixed(2) + ")";
  };

  ProductHasMultipleImages() {
    let productImagesCount = 0;
    if (this.pspes.modifiedPointStoreProduct != undefined && this.pspes.modifiedPointStoreProduct != null) {
      if (this.pspes.modifiedPointStoreProduct.VariationsData != null) {
        this.pspes.modifiedPointStoreProduct.VariationsData.forEach((variation, index, array) => {
          if (variation.VariationImageData != undefined && variation.VariationImageData != null)
            productImagesCount++;
        });
      }
      if (productImagesCount > 0 || (this.pspes.modifiedPointStoreProduct.imageString != undefined && this.pspes.modifiedPointStoreProduct.imageString.length > 1))
        return true;
    }
  }

  getMultipleImagesCount() {
    let productImagesCount = 0
    if (this.pspes.modifiedPointStoreProduct != undefined && this.pspes.modifiedPointStoreProduct != null) {
      if (this.pspes.modifiedPointStoreProduct.VariationsData != null) {
        this.pspes.modifiedPointStoreProduct.VariationsData.forEach((variation, index, array) => {
          if (variation.VariationImageData != undefined && variation.VariationImageData != null)
            productImagesCount++;
        });
      }
      if (this.pspes.modifiedPointStoreProduct.imageString != undefined && (this.pspes.modifiedPointStoreProduct.imageString.length > 1 || productImagesCount > 0)) {
        productImagesCount += this.pspes.modifiedPointStoreProduct.imageString.length;
        return productImagesCount - 1;
      }
    }
  }

  checkImageNotAvailable(): boolean{
    let check = false;
    //update mode
    if(this.pspes.modifiedPointStoreProduct.PointStoreProductID > 0){
      check = this.pspes.modifiedPointStoreProduct.ProductImageID === 0 && this.pspes.modifiedPointStoreProduct.imageString.length === 0;
    }else {//create mode
      check = this.pspes.modifiedPointStoreProduct.imageString.length === 0;
    }
    return check;
  }

  getImageNotAvailableTitle():string {
    return this.cvLocalizationService.getCachedText("MarketPlace_Management", "Image_Not_Available", "Image_Not_Available");
  }

  getLocalizationText(section:string, key: string, defaultValue:string): string{
    return this.cvLocalizationService.getCachedText(section, key, defaultValue);
  }
  
}
